/* eslint-disable prettier/prettier */
import Vue from 'vue'
import Vuex from 'vuex'

import userManagement from './modules/userManagement'
import client from './modules/client'
import delivery from './modules/delivery'
import billing from './modules/billing'
import supplier from './modules/supplier'
import porequest from './modules/porequest'
import salesquote from './modules/salesquote'
import pullouttoclient from './modules/pullouttoclient'
import ticketingforitem from './modules/ticketingforitem'
import podelivery from './modules/podelivery'
import purchaseorder from './modules/purchaseorder'
import productorservice from './modules/productorservice'
import purchaseordertoreceive from './modules/purchaseordertoreceive'
import misc from './modules/misc'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    userManagement,
    client,
    supplier,
    porequest,
    salesquote,
    pullouttoclient,
    ticketingforitem,
    podelivery,
    purchaseorder,
    productorservice,
    misc,
    purchaseordertoreceive,
    delivery,
    billing
  }
})